<p-toast></p-toast>
<div>
  <div *ngIf="isLoading" class="{{isLoading ? 'loadingOverlay center-loader' : 'center-loader'}}">
    <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
    </p-progressSpinner>
  </div>
  <div class="interview-header">
    <div class="header-top-row">
      <div class="candidate-profile">
        <div class="candidate-avatar" *ngIf="!candidateDetails?.photo">
          {{userEventData?.candidate_name?.charAt(0)?.toUpperCase() || 'C'}}
        </div>
        <img *ngIf="candidateDetails?.photo" [src]="candidateDetails.photo" class="candidate-photo" alt="Candidate">
        <div class="candidate-meta">
          <h3 class="candidate-name-text">{{userEventData?.candidate_name || 'Candidate'}}</h3>
          <div class="meta-sub">
            <span class="candidate-email-inline" *ngIf="candidateDetails?.email_id">{{candidateDetails.email_id}}</span>
            <span class="meta-divider" *ngIf="candidateDetails?.email_id && candidateDetails?.mobile_number">•</span>
            <span class="candidate-phone-inline"
              *ngIf="candidateDetails?.mobile_number">+{{candidateDetails?.country_code || '91'}}
              {{candidateDetails.mobile_number}}</span>
          </div>
        </div>
      </div>
      <div class="header-actions">
        <button type="button" *ngIf="candidateDetails?.resume_cv" (click)="openResume()" [disabled]="isLoadingResume" class="resume-btn"
          aria-label="Open Resume" pTooltip="Open Resume" tooltipPosition="bottom">
          <i class="pi pi-spin pi-spinner" *ngIf="isLoadingResume"></i>
          <i class="pi pi-file-pdf" *ngIf="!isLoadingResume"></i> Resume
        </button>
        <button type="button" (click)="openCandidateDetailsSidebar()" pTooltip="View Candidate Details"
          aria-label="View Candidate Details" tooltipPosition="bottom"
          class="view-details-btn">
          View Details
        </button>
        <button pButton *ngIf="!meetingEnd" [label]="feedbackMode === 'create' ? 'Submit Feedback' : 'Edit Feedback'"
          (click)="openFeedbackSlider()" class="feedback-btn"></button>
      </div>
    </div>
  </div>
  <div class="score-head" *ngIf="candidateAssessmentDetails?.length > 0" id="score-head">
    <div class="score-container" style="display: flex;overflow: hidden; width: 90%;font-size: 15px;" id="score-container">
      <div class="assessment" *ngFor="let item of candidateAssessmentDetails,index as i">
        <div class="flex-text-wrap">
          <span class="score-number">{{i+1}}</span>
          <span>{{item.stageName ? item.stageName : '-'}}</span>
        </div>
        <div class="flex-text-wrap">
          <label class="score-label">(Total: {{isNumber(item.marks) ? item.marks : '-'}}/{{item.total_marks ? item.total_marks : '-'}})</label>
          <i title="Test Info" class="pi pi-info-circle test-chart" (click)="toggleFunction(op,$event);"></i>
        </div>
        <p-popover #op [style]="{'width': '350px'}" styleClass="no-padding-overlay">
          <ng-template #content *ngIf="item.section_wise_marks.length > 0">
            <div class="section-container" *ngFor="let section of item.section_wise_marks"
            style="padding: 10px 40px 10px 15px;
            display: flex; color: black;
            justify-content: space-between;
            align-items: center;">
              <div class="flex-text-wrap">
                <span>{{section.name}} Score</span>
              </div>
              <div class="flex-text-wrap">
                <span>{{isNumber(section.marks) ? section.marks : '-'}} / {{isNumber(section.total_marks) ? section.total_marks : '-'}}</span>
              </div>
            </div>
          </ng-template>
      </p-popover>
      </div>
    </div>
    <div class="mark-arrows" *ngIf="showBackNext === true">
      <div class="arrow-container" >
        <div class="back-btn" (click)="handleSectionTabBack()" style="display: flex;">
          <i title="Back" class="pi pi-angle-left back-arrow"></i>
        </div>
        <div class="next-btn"(click)="handleSectionTabNext()" style="display: flex;">
          <i title="Forward" class="pi pi-angle-right front-arrow"></i>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="adminReload" class="candidate-body-content">
    Reloading Interview.
  </div>
  <!-- 100ms Prebuilt -->
  <div *ngIf="hmsRoomUrl" class="hms-container" style="height:80vh; margin-top: 0.5rem; position: relative;">
    <div *ngIf="hmsIframeLoading" class="hms-loading-overlay">
      <p-progressSpinner [style]="{height: '36px', width: '36px'}" strokeWidth="5" animationDuration="0.6s">
      </p-progressSpinner>
      <span class="hms-loading-text">Loading interview room...</span>
    </div>
    <iframe [src]="hmsRoomUrl" title="HMS interview room" allow="camera;microphone;fullscreen;display-capture;autoplay"
      style="width:100%;height:100%;border:0;" (load)="onHmsIframeLoaded()"></iframe>
  </div>

  <!-- JaaS Container -->
  <div id="jaas-container" class="live-chat"
    style="height:80vh; background-color: black; margin-top: 0.5rem; display: none;">
  </div>
  <div *ngIf="meetingEnd" class="interview-complete-message">
    <div class="message-content">
      <i class="pi pi-check-circle success-icon"></i>
      <h2>Interview Completed</h2>
      <p>{{feedbackMode === 'create' ? 'Please submit the feedback form before closing the tab' : 'You can edit your feedback If required before closing the tab'}}</p>
      <button pButton 
        [label]="feedbackMode === 'create' ? 'Submit Feedback' : 'Edit Feedback'" 
        class="p-button-primary"
        (click)="openFeedbackSlider()">
      </button>
    </div>
  </div>

  <p-dialog 
    [(visible)]="feedbackSlider"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '1050px', maxHeight: '90vh' }"
    [baseZIndex]="10000"
    styleClass="feedback-dialog"
    (onHide)="onFeedbackDialogHide()">
    
    <ng-template pTemplate="header">
      <div class="feedback-dialog-header">
        <h2 class="dialog-title">Feedback</h2>
      </div>
    </ng-template>

    <div *ngIf="loadingOtherFeedback" class="jitsi-feedback-loading">
      <p-progressSpinner [style]="{'height': '32px', 'width': '32px'}" strokeWidth="4"></p-progressSpinner>
      <span>Loading panel members...</span>
    </div>

    <div *ngIf="!loadingOtherFeedback" class="feedback-dialog-body"
      [class.has-panel]="panelMembers.length > 1 || (panelMembers.length > 0 && feedbackMode === 'create')">
      <div class="panel-members-sidebar"
        *ngIf="panelMembers.length > 1 || (panelMembers.length > 0 && feedbackMode === 'create')">
        <div class="panel-members-title">PANEL MEMBERS ({{ panelMembers.length }})</div>
        <div class="panel-member-item" *ngFor="let member of panelMembers"
          [class.active]="(member.isVirtual && selectedPanelMemberFormId === null && selectedPanelMemberId === member.submitted_by_id) || (!member.isVirtual && selectedPanelMemberFormId === member.form_id)"
          (click)="selectPanelMember(member)">
          <div class="panel-member-avatar" [style.background-color]="getAvatarColor(member.submitted_by_name)">
            {{ getInitials(member.submitted_by_name) }}
          </div>
          <div class="panel-member-info">
            <span class="panel-member-name">
              {{ member.submitted_by_name }}
              <span *ngIf="isCurrentUser(member)" class="you-tag">(You)</span>
            </span>
            <span class="panel-member-date" *ngIf="member.isVirtual" style="color: #ef4444;">
              Not Submitted
            </span>
            <span class="panel-member-date" *ngIf="!member.isVirtual">
              <i class="pi pi-check-circle" style="color: #22c55e; font-size: 11px;"></i>
              {{ member.submitted_date | date: 'dd-MM-yyyy hh:mm a' }}
            </span>
          </div>
          <i class="pi pi-chevron-right panel-member-arrow"></i>
        </div>
      </div>
      <div class="feedback-form-content">
        <app-feedback-form #feedbackForm *ngIf="formUuid && formUuid.trim().length > 0" 
          [feedbackMode]="feedbackMode" [headerData]="paramItems" [candidateDetails]="userEventData"  
          (closeFeedbackSlider)="onCloseFeedbackSlider($event)" [formUuid]="formUuid">
        </app-feedback-form>
      </div>
    </div>
  </p-dialog>

</div>

<!-- Candidate Details Sidebar -->
<p-drawer [(visible)]="showCandidateDetailsSidebar" position="right" [style]="{width: '650px'}">
  <ng-template pTemplate="content">
    <app-candidate-info *ngIf="showCandidateDetailsSidebar" [selectedUser]="candidateInfoPayload" [disableStage]="true"
      [disableFeedback]="false" [disableActivity]="false" [showBackButton]="false">
    </app-candidate-info>
  </ng-template>
</p-drawer>